import React from 'react';
import classnames from 'classnames';

const steps = [
  {
    label: '不具合内容の入力',
    title: (
      <span>
        <span className="small bg-black text-white py-1 px-2 mr-2">
          STEP 1
        </span>
        <span>
          不具合内容の入力
        </span>
      </span>
    ),
  },
  {
    label: 'パーツの選択',
    title: (
      <span>
        <span className="small bg-black text-white py-1 px-2 mr-2">
          STEP 2
        </span>
        <span>
          パーツの選択
        </span>
      </span>
    ),
  },
  {
    label: 'お客様情報の入力',
    title: (
      <span>
        <span className="small bg-black text-white py-1 px-2 mr-2">
          STEP 3
        </span>
        <span>
          お客様情報の入力
        </span>
      </span>
    ),
  },
  {
    label: '確認',
    title: 'お問合せ内容の確認',
  },
  {
    label: 'お問合せ完了',
    title: 'お問合せ完了',
  },
];

export default function TroubleInquiryFlowSection(props) {
  const { activeIndex } = props;
  const activeStep = steps[activeIndex];

  return (
    <section className="container-fluid bg-light-grey p-3">
      <h5 className="text-center font-weight-bold p-3">
        {activeStep.title}
      </h5>
      <div>
        <ul className="stepflow m-0">
          {
            steps.map((step, i) => {
              return (
                <li className={classnames({ completed: i < activeIndex, active: i === activeIndex, })}>
                  <span className="bubble" />
                  {step.label}
                </li>
              );
            })
          }
        </ul>
      </div>
    </section>
  )
};

